export const BUSINESS_ROLE = Object.freeze({
  PUBLIC: 'PUBLIC',
  BUSINESS_USER: 'BUSINESS_USER',
  BUSINESS_ADMIN: 'BUSINESS_ADMIN',
});

export const ROLE_LEVEL = Object.freeze({
  [BUSINESS_ROLE.PUBLIC]: 0,
  [BUSINESS_ROLE.BUSINESS_USER]: 1,
  [BUSINESS_ROLE.BUSINESS_ADMIN]: 2,
});

export const AccessType = {
  ANONYMOUS: 'anonymous',
  AUTHORIZED: 'authorized',
  UNAUTHORIZED: 'unAuthorized',
};

export const fileStackKey = 'Ach6MsgoQHGK6tCaq5uJgz';
export const initialUrl = '/dashboard'; // this url will open after login
export const exportCsv = 'CSV';
export const exportPdf = 'PDF';
